import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Lock, Clock } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

// Shows trial countdown or a calm "service suspended" banner from the server entitlement.
export function EntitlementBanner() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: ["entitlement"],
    queryFn: async () => (await api.get("/billing/status")).data,
    retry: false,
  });
  if (!data) return null;

  if (data.state === "trial_active" && data.trial_days_left != null) {
    return (
      <div data-testid="trial-banner" className="mb-4 flex items-center gap-2 rounded-xl border border-[#C4DFD2] bg-[#F2F7F4] px-3.5 py-2.5 text-sm text-[#2D5A4C]">
        <Clock size={16} className="shrink-0" />
        <span className="font-semibold">{t("xp.gTrial").replace("{n}", data.trial_days_left)}</span>
      </div>
    );
  }

  if (!data.service_access) {
    return (
      <div data-testid="paywall-banner" className="mb-4 rounded-2xl border border-[#F8C7C0] bg-[#FDF2F0] p-4">
        <div className="flex items-center gap-2 text-[#C03A2B]">
          <Lock size={16} className="shrink-0" />
          <p className="font-display text-sm font-bold">{t("xp.gExpiredTitle")}</p>
        </div>
        <p className="mt-1 text-xs text-[#7A5652]">{t("xp.gExpiredBody")}</p>
        <button
          data-testid="paywall-subscribe"
          onClick={() => navigate("/subscription")}
          className="mt-3 w-full rounded-xl bg-[#2D5A4C] py-2.5 text-sm font-semibold text-white active:scale-[0.99]"
        >
          {t("xp.gSubscribe")}
        </button>
      </div>
    );
  }
  return null;
}
